import type { CheckIn } from '@/types/check-in';
import type { Paginated } from '@/types/pagination';
import type {
  CheckInWire,
  PaginatedCheckInResponseWire,
} from '../schemas/check-in';

/**
 * Convert a check-in from wire format to domain format.
 * Maps snake_case to camelCase and ISO timestamps to Unix milliseconds.
 * Nullable wire fields stay nullable; optional JOIN fields stay optional.
 */
export function mapCheckInWireToDomain(wire: CheckInWire): CheckIn {
  return {
    id: wire.id,
    userId: wire.user_id,
    businessId: wire.business_id,
    menuItemId: wire.menu_item_id,
    ratingId: wire.rating_id,
    status: wire.status,
    latitude: wire.latitude,
    longitude: wire.longitude,
    locationAccuracyMeters: wire.location_accuracy_meters,
    diningType: wire.dining_type,
    createdAt: new Date(wire.created_at).getTime(),
    occurredAt: wire.occurred_at ? new Date(wire.occurred_at).getTime() : null,
    ratingKey: wire.rating_key,
    ratingLabel: wire.rating_label,
    businessName: wire.business_name,
    menuItemName: wire.menu_item_name,
    photosCount: wire.photos_count,
    hasReview: wire.has_review,
  };
}

/**
 * Convert a paginated check-ins response from wire format to the domain
 * Paginated<CheckIn> envelope (camelCase).
 */
export function mapPaginatedCheckInsWireToDomain(
  wire: PaginatedCheckInResponseWire
): Paginated<CheckIn> {
  return {
    items: wire.items.map(mapCheckInWireToDomain),
    total: wire.total,
    page: wire.page,
    perPage: wire.per_page,
    totalPages: wire.total_pages,
  };
}
